<template>
  <ModalContainer queryParam="editAux" ref="modalEditImagen" size="lg">
    <b-card class="m-0">
      <h3 class="mb-2 text-center">Editar laboratorio auxiliar</h3>

      <FormAddLabAux
        v-if="indexToEdit"
        :examenesAuxiliares="examenesAuxiliares"
        :indexToEdit="indexToEdit"
      />
      
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from '@/shared/components';
import FormAddLabAux from "./FormAddLabAux.vue";

export default {

  name: "EditarEnvioLabAux",

  props: {
    examenesAuxiliares: {
      type: Array,
      required: true
    },

  },


  components: {
    FormAddLabAux,
    ModalContainer
  },


  created() {
    this.indexToEdit = this.$route.query.editAux
  },

  data(){
    return {
      indexToEdit: null,
    }
  },

  methods: {
    async viewFormEdit(index){
      await this.$bvModal.show("editLabAux");
      this.indexToEdit = index.toString();
    },
  },


  watch:{
    '$route.query.editAux':{
      immediate: true,
      handler(){
        this.indexToEdit = this.$route.query.editAux
      }
    }
  }

}
</script>
